import type { ComponentProps, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Button, Flex } from '@spotify-internal/encore-web';
import { AuthScreen } from '@spotify/confidence-core-react';

import styles from './IntroStep.module.css';

type IntroStepProps = ComponentProps<'div'> & {
  title: ReactNode;
  description?: ReactNode;
  buttonLabel?: string;
  onNext?: () => void;
  disabled?: boolean;
};

export const IntroStep = ({
  title,
  description,
  buttonLabel = 'Continue',
  onNext,
  disabled,
  ...rootProps
}: IntroStepProps) => (
  <AuthScreen.Root {...rootProps}>
    <AuthScreen.Main>
      <Flex
        className={styles.content}
        direction="column"
        gap="looser-3"
        alignItems="center"
      >
        <Link to="/" aria-label="Go to homepage">
          <AuthScreen.Logo />
        </Link>
        <Flex direction="column" gap="tighter-3" alignItems="center">
          <AuthScreen.Title>{title}</AuthScreen.Title>
          {description && (
            <AuthScreen.Description>{description}</AuthScreen.Description>
          )}
        </Flex>
        {onNext && (
          <Button
            variant="primary"
            colorSet="inverted"
            size="large"
            data-testid="continue"
            onClick={onNext}
            disabled={disabled}
          >
            {buttonLabel}
          </Button>
        )}
      </Flex>
    </AuthScreen.Main>
  </AuthScreen.Root>
);
